<template>
  <div class="project-commit-revert-form">
    <div class="project-commit-revert-form__body">
      <div
        v-if="formErrors && (formErrors.commitHash || formErrors.noPermission)"
        class="project-commit-revert-form__body-errors mb-3"
      >
        <gf-custom-alert
          variant="danger"
          class="mb-2"
        >
          <template #body>
            <b v-if="formErrors.commitHash">
              <i class="gf-icon gf-icon-alert mr-2"></i>
              <span>{{ formErrors?.commitHash }}</span>
            </b>
            <b v-if="formErrors.noPermission">
              <i class="gf-icon gf-icon-alert mr-2"></i>
              <span>{{ formErrors?.noPermission }}</span>
            </b>
          </template>
        </gf-custom-alert>
      </div>

      <p>{{ $t('commit.revert.revertCommitDescription') }}</p>

      <b>
        {{ $t('commit.revert.selectedTargetBranchTitle') }}
        <code>{{ currentBranch }}</code>
      </b>

      <div class="custom-control custom-checkbox my-2">
        <input
          type="checkbox"
          :id="`initWithNewBranch-${hash}`"
          class="custom-control-input"
          v-model="initWithNewBranch"
          @change="onInitWithNewBranchChange"
        />
        <label
          class="text-muted custom-control-label"
          :for="`initWithNewBranch-${hash}`"
        >
          {{ $t('commit.revert.createNewBranchForRevert') }}
        </label>
      </div>

      <div
        v-if="initWithNewBranch"
        class="form-group"
      >
        <label
          class="font-weight-bolder"
          for="revertCommitNewBranchName"
        >
          {{ $t('commit.revert.selectSourceBranchTitle') }}
        </label>
        <input
          class="form-control form-control-sm"
          id="revertCommitNewBranchName"
          v-model="newBranchName"
        />
        <div
          class="invalid-feedback d-flex"
          v-if="formErrors && formErrors.newBranch"
        >
          {{ formErrors?.newBranch }}
        </div>
      </div>

      <div
        v-if="initWithNewBranch"
        class="custom-control custom-checkbox my-2"
      >
        <input
          type="checkbox"
          :id="`initNewMergeRequest-${hash}`"
          class="custom-control-input"
          v-model="initNewMergeRequest"
        />
        <label
          class="text-muted custom-control-label"
          :for="`initNewMergeRequest-${hash}`"
        >
          {{ $t('commit.revert.revertAndCreateNewMergeRequestTitle') }}
        </label>
      </div>

      <p class="small text-secondary">
        {{ $t('commit.revert.revertCommitNote') }}
      </p>
    </div>
    <div class="project-commit-revert-form__footer">
      <button
        type="button"
        class="btn btn-dark btn-sm m-1"
        @click="cancel"
      >
        {{ $t('commit.revert.cancel') }}
      </button>

      <button
        type="button"
        class="btn btn-success btn-sm m-1"
        :disabled="isSubmitDisabled"
        @click="submit"
      >
        {{ $t('commit.revert.submit') }}
      </button>
    </div>
  </div>
</template>

<script>
import CommitMessages from '@/shared-modules/modules/commit/commit.messages';
import ProjectBranchSelector from '@/shared-modules/shared-components/shared/project-branch-selector.vue';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
export default {
  name: 'project-commit-revert-form',
  components: {
    ProjectBranchSelector
  },
  props: {
    hash: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      initWithNewBranch: false,
      initNewMergeRequest: false,
      newBranchName: ''
    };
  },
  computed: {
    isSubmitDisabled() {
      return this.initWithNewBranch && this.newBranchName?.length === 0;
    },
    currentBranch() {
      return this.$route?.query?.branch;
    },
    formErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.COMMIT_REVERT_FORM);
    }
  },
  methods: {
    onInitWithNewBranchChange() {
      this.newBranchName = '';
      this.initNewMergeRequest = !this.initNewMergeRequest;
    },
    submit() {
      this.$emit('submit', {
        newBranchName: this.newBranchName,
        initNewMergeRequest: this.initNewMergeRequest,
        initWithNewBranch: this.initWithNewBranch
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  i18n: {
    messages: CommitMessages
  }
};
</script>

<style lang="scss">
$this: '.project-commit-revert-form';

#{$this} {
  #{$this}__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>